export default __webpack_public_path__ + "4c3f020d3e9ccc3a95909d3ff8547de1.svg";